<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import DeviceInfo from '@/modules/util/deviceInfo'
  export default {
    computed: {
      ...mapGetters([
        'MainMenuLayout',
        'resource',
        'CommentData'
      ]),
      CommentAuthor: {
        get() {
          return this.CommentData.CommentAuthor
        },
        set(value) {
          this.updateUserCommentData({CommentAuthor: value})
        }
      },
      CommentEmail: {
        get() {
          return this.CommentData.CommentEmail
        },
        set(value) {
          this.updateUserCommentData({CommentEmail: value})
        }
      },
      Comment: {
        get() {
          return this.CommentData.Comment
        },
        set(value) {
          this.updateUserCommentData({Comment: value})
        }
      },
      // /*eslint-disable*/
      // templateTranslate(){
      //   console.log('Give value',this.resource.termandcondtions)
      //   this.resource.termandcondtions
      // }
    },
    data() {
      return {
        textarea : null
      }
    },
    methods: {
      ...mapActions([
        'updateUserCommentData'
      ]),
      onPopupOpened () {
        document.addEventListener("backbutton", this.onBackClick)
      },
      onPopupClosed () {
        document.removeEventListener("backbutton", this.onBackClick)
      },
      onBackClick (event) {
        this.$refs.commentpopup.close(true)
        event.preventDefault()
      },
      showContent () {
         this.$f7.views.main.router.navigate(`/termcondtion`)
          setTimeout(() => {
          window.location.reload()
          },500)
      },
      addComment: function() {
        if (Helper.IsUserActionAllow()) {
          let data = this.$store.state.ContentPage.UserComment
          let message = ''
          if (Helper.IsNullOrEmpty(data.CommentAuthor)) {
            message += this.resource.errorCommentMessageName + '<br/>'
          }
          if (Helper.IsNullOrEmpty(data.CommentEmail)) {
            message += this.resource.errorCommentMessageEmail + '<br/>'
          } else if (!Helper.validateEmail(data.CommentEmail)) {
            message += this.resource.errorCommentMessageValidEmail + '<br/>'
          }
          if (Helper.IsNullOrEmpty(data.Comment)) {
            message += this.resource.errorCommentMessageComment + '<br/>'
          }
          if (message !== '') {
            this.$f7.notification.create({
              title: this.resource.errorCommentTitle,
              subtitle: message,
              cssClass: 'error-notification',
              closeOnClick: true,
              closeTimeout: 3000
            }).open()
          } else {
            let comment = this.$store.state.ContentPage.UserComment
            comment.NotificationContent.Comment = comment.Comment
            this.$store.dispatch({
              type: 'addPostComment',
              comment
            })
            this.$f7.notification.create({
              title: this.resource.succesCommentTitle,
              subtitle: this.resource.succesCommentMessage,
              cssClass: 'success-notification',
              closeOnClick: true,
              closeTimeout: 3000
            }).open()
            this.$refs.commentpopup.close()
          }
        } else {
          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid
              ? this.resource.AndroidDownload
              : this.resource.AppleDownload,
            $f7: this.$f7
          }
          this.$showModal(modalOptions)
        }
      }
    }
  }
</script>
<template>
  <f7-popup
   @popup:opened="onPopupOpened"
   @popup:closed="onPopupClosed"
   id="comment-popup" ref="commentpopup"
   class="comment-popup" tablet-fullscreen>
    <f7-page :page-content="false">
      <f7-navbar>
        <f7-nav-left>
          <f7-link class="closebtnlbl" popup-close>{{resource.closeBtn}}</f7-link>
        </f7-nav-left>
        <f7-nav-title>{{resource.addCommentBtn}}</f7-nav-title>
        <f7-nav-right>
        </f7-nav-right>
      </f7-navbar>
      <div class="backgroundimg"></div>
      <f7-page-content>
        <f7-list>
          <f7-list-item>
            <f7-icon slot="media" f7="person"></f7-icon>
            <f7-input :class="'textinput'+$f7.theme" :value="CommentAuthor" @input="CommentAuthor = $event.target.value" type="text" :placeholder="resource.nameLbl" :clear-button = "true"/>
          </f7-list-item>
        </f7-list>
        <f7-list>
          <f7-list-item>
            <f7-icon slot="media" f7="email"></f7-icon>
            <f7-input :class="'textinput'+$f7.theme" :value="CommentEmail" @input="CommentEmail = $event.target.value" type="text" :placeholder="resource.emailLbl" :clear-button = "true"></f7-input>
          </f7-list-item>
        </f7-list>
        <f7-list>
          <f7-list-item>
            <f7-icon slot="media" f7="chat"></f7-icon>
            <div class="item-input-wrap">
              <!-- <textarea type="textarea" rows='5' :value="Comment" @input="Comment = $event.target.value" :placeholder="resource.commentLbl" style="height: auto;">
              </textarea> -->
              <f7-input :class="'textinput'+$f7.theme" type="textarea" :value="Comment" @input="Comment = $event.target.value" :placeholder="resource.commentLbl" clear-button></f7-input>
            </div>
          </f7-list-item>
        </f7-list>
          <div>
        <label style="display: inline-block">
            <input style="vertical-align: middle"
                        type="checkbox" />
            <span style="vertical-align: middle">{{resource.beforeterms}}   <f7-button style="position: relative; top: -23px;left: 124px;" @click="showContent()">{{resource.termandcondtions}} </f7-button>
            </span>
        </label>
    </div>
        <f7-block>
          <f7-button big fill @click="addComment()">{{resource.addCommentBtn}}</f7-button>
        </f7-block>
      </f7-page-content>
    </f7-page>
  </f7-popup>
</template>

<style scoped>
  .closebtnlbl {
  font-size: 14px ;
  }
.ios .button {
  border: 0
}
  /* min-height: 40px; */
</style>



// WEBPACK FOOTER //
// src/components/shared/CommonComment.vue